import * as storymapStoreModule from '../../../store';
import { RenameCardColor } from '../../../store/actions/colors/renameCardColor';
import { AddOrUpdateStorymapColorMapping } from '..';

export const createAddOrUpdateStorymapColorMapping = async (action: RenameCardColor) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const cmd = new AddOrUpdateStorymapColorMapping(state.id, action.color, action.name, true);

    return cmd;
};
